import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Home from '../views/home.vue'
import HomeDd from '../views/home2.vue'
import Nav from '../views/nav.vue'
import store from '../store/index'
import { Message } from 'element-ui'
import { getCookie } from "@/utils/cokiesFun";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: 'Login'
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			isTabsPage: false,
		}
	},
	{
		path: '/nav',
		name: 'Nav',
		component: Nav,
		meta: {
			isTabsPage: false,
		}
	},
	{
		path: '/homeDd',
		name: 'HomeDd',
		component: HomeDd,
		redirect: '/homeDd/yydd',
		children: [
			{
				path: 'yydd',
				name: 'Yydd',
				component: () => import('@/views/home2/yydd.vue'),
				meta: {
					title: '语音调度',
				}
			},
			{
				path: 'dwdt',
				name: 'Dwdt',
				component: () => import('@/views/home2/dwdt.vue'),
				meta: {
					title: '定位地图',
				}
			},
			{
				path: 'lycx',
				name: 'Lycx',
				component: () => import('@/views/home2/lycx.vue'),
				meta: {
					title: '录音查询',
				}
			},
			{
				path: 'spdd',
				name: 'Spdd',
				component: () => import('@/views/home2/spdd.vue'),
				meta: {
					title: '视频调度',
				}
			},
			{
				path: 'xtsq',
				name: 'Xtsq',
				component: () => import('@/views/home2/xtsq.vue'),
				meta: {
					title: '系统授权',
				}
			},
			{
				path: 'demo',
				name: 'Demo',
				component: () => import('@/views/home2/demo.vue'),
				meta: {
					title: '语音',
				}
			},
			{
				path: 'demo2',
				name: 'Demo2',
				component: () => import('@/views/home2/demo2.vue'),
				meta: {
					title: '语音2',
				}
			},
			{
				path: 'demo3',
				name: 'Demo3',
				component: () => import('@/views/home2/demo3.vue'),
				meta: {
					title: '语音3',
				}
			},
		]
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		redirect: '/home/systemng',
		children: [
			{
				path: 'systemng',
				name: 'Systemng',
				component: () => import('@/views/components/systemng'),
				meta: {
					title: '系统管理',
					isTabsPage: true,
				}
			},
			{
				path: 'devicemng',
				name: 'Devicemng',
				component: () => import('@/views/components/devicemng'),
				meta: {
					title: '设备管理',
					isTabsPage: true,
				}
			},
			{
				path: 'systemtp',
				name: 'Systemtp',
				component: () => import('@/views/components/systemtp'),
				meta: {
					title: '系统拓扑',
					isTabsPage: true,
				}
			},
			{
				path: 'wrannow',
				name: 'Wrannow',
				component: () => import('@/views/components/wrannow'),
				meta: {
					title: '实时告警',
					isTabsPage: true,
				}
			},
			{
				path: 'wranold',
				name: 'Wranold',
				component: () => import('@/views/components/wranold'),
				meta: {
					title: '历史告警',
					isTabsPage: true,
				}
			},
			{
				path: 'severs',
				name: 'Severs',
				component: () => import('@/views/components/severs'),
				meta: {
					title: '服务配置',
					isTabsPage: true,
				}
			},
			{
				path: 'authorize',
				name: 'Authorize',
				component: () => import('@/views/components/authorize'),
				meta: {
					title: '授权管理',
					isTabsPage: true,
				}
			},
		]
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})
router.beforeEach((to, from, next) => {
	// if (to.meta.title) { // 如果设置标题，拦截后设置标题
	// 	document.title = to.meta.title
	// }

	if (to.path !== '/login') {
		// 判断登录状态
		if (!getCookie('token')) {
			Message.error('请先登录')
			next('/login')
			return
		}
		// 判断是否需要添加到tabs标签
		if (to.meta.isTabsPage) {
			const tabsItem = {
				name: to.name,
				title: to.meta.title,
				path: to.path
			}
			store.commit('ADD_TABS_VALUE', tabsItem)
		}
	}
	next()
})
export default router
